import { useState, useEffect, useRef } from 'react'
import { motion } from 'framer-motion'
import { AflfGem, AflfZebra } from '../../../theme/elements'

import CSS from './promo-graphic.module.css'

export const PromoGraphic = ({ children }) => {
    return (
        <div className={CSS.layout}>
            <div className={CSS.heroGraphic}>
                <img src="/assets/img/homepage/finance-forum.jpg" alt="" />
            </div>
            
            <section className={` ${CSS.descriptor} block`}>
                <div className="container">
                    { children }
                </div>
            </section>
        </div>
    )
}

